import React from "react";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../../utils/images";

function AboutHero() {
    const navigate = useNavigate();

    return (
        <section className="bg-white border-b border-[#e4e5e7]">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[56px] md:py-[80px]">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-[40px] lg:gap-[64px] items-center">

                    {/* Content */}
                    <div>

                        <h1 className="font-semibold text-[36px] md:text-[52px] text-[#212326] tracking-[-1px] leading-[1.1] mb-[20px]">
                            Your one-stop{" "}
                            <span className="text-[#ff5323]">
                                marketplace
                            </span>{" "}
                            for printing.
                        </h1>

                        <p className="font-medium text-[17px] md:text-[19px] text-[#717182] leading-[1.6] mb-[32px] max-w-[560px]">
                            SignetPrint connects you with print shops and
                            suppliers in one central hub. Send files, discover
                            services, and manage everything - no more email
                            chains, lost files, or wasted trips.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-[12px]">
                            <button
                                onClick={() => navigate("/marketplace")}
                                className="inline-flex items-center justify-center gap-[8px] px-[28px] py-[14px] rounded-[12px] bg-[#ff5323] text-white font-semibold text-[15px] hover:bg-[#e64a1f] transition-colors no-underline"
                            >
                                Browse Marketplace

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-[16px] h-[16px]"
                                >
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </button>

                            <button
                                onClick={() => navigate("/onboarding/plan")}
                                className="inline-flex items-center justify-center gap-[8px] px-[28px] py-[14px] rounded-[12px] bg-white text-[#212326] font-semibold text-[15px] hover:bg-[#f8f8fa] transition-colors no-underline border border-[#e4e5e7]"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-[16px] h-[16px]"
                                >
                                    <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
                                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                    <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
                                    <path d="M2 7h20" />
                                    <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" />
                                </svg>

                                List Your Business
                            </button>
                        </div>
                    </div>

                    {/* Image */}
                    <div className="relative">
                        <div className="aspect-[4/3] rounded-[20px] overflow-hidden border border-[#e4e5e7]">
                            <img
                                src={IMAGES.aboutHero}
                                alt="Print shop in action"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default AboutHero;
